export default {
  placeholder: 'Filtrovať podľa receptúry',
};
